import * as ids from 'short-id';
import { MediaIntegrationId } from 'components/VideoTemplateEditor/types/core';
import { PodcastTemplateConfig } from 'redux/middleware/api/podcast-service';
import { viewportToPct } from '../../../utils';
import { Layer, VideoClip, VideoClipState } from '../types';

/**
 *
 * @param layers an array of layer ids where the index of the layer in the array
 * corresponds to the layer's order.  a layer corresponds to a track in the
 * editor. slideshow and videoClips share the same track so the layers array passed
 * in here can be the output of the getSlideshow function
 */
export function getVideoClips(
  config: PodcastTemplateConfig,
  layers: Layer[],
): VideoClipState {
  const videoClips = config?.videoClips ?? [];

  return videoClips.reduce(
    (acc, clip, index) => {
      const layer = layers[clip.layerId];

      if (layer?.type !== 'media') {
        throw new Error(
          `Expected video asset to reference layer of type "media" but got ${layer?.type}`,
        );
      }

      const id = ids.generate();
      const clipState: VideoClip = {
        id,
        layerId: layer.id,
        original: clip,
        position: {
          left: viewportToPct(clip.position?.left),
          top: viewportToPct(clip.position?.top),
        },
        previewThumbnail: clip.previewThumbnail,
        style: {
          height: viewportToPct(clip.style?.height),
          width: viewportToPct(clip.style?.width),
        },
        videoUrl: clip.videoUrl,
        integrationData: { id: MediaIntegrationId.VIDEOCLIP },
        templateIndex: index,
      };
      acc.order.push(id);
      acc.data[id] = clipState;
      return acc;
    },
    { order: [], data: {} },
  );
}
